<template>
  <section class="upload">
    <template v-if="image">
      <button @click="image = null">&times; uus pilt</button>
      <Cropper classname="upload__cropper" :src="image" ref="cropper" :stencilComponent="FaceStencil" />
      <button class="button" @click="crop">valmis <arrow-icon /></button>
    </template>
    <div class="button-wrapper" v-else>
      <label class="button">
        <input type="file" @change="uploadImage" accept="image/*" />
        Tee või lae üles näopilt <arrow-icon />
      </label>
    </div>
  </section>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import FaceStencil from '@/components/FaceStencil'
import ArrowIcon from '@/assets/right-arrow.svg'

export default {
  name: 'upload-avatar',
  data() {
    return {
      image: null,
      FaceStencil,
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }
    }
  },
  components: { ArrowIcon, Cropper },
  methods: {
    roundEdges(canvas) {
      var context = canvas.getContext('2d')
      var width = canvas.width
      var height = canvas.height
      context.globalCompositeOperation = 'destination-in'
      context.beginPath()
      context.scale(1, height / width)
      context.arc(width / 2, width / 2, width / 2, 0, Math.PI * 2)
      context.closePath()
      context.fill()
      return canvas
    },
    crop() {
      const { canvas } = this.$refs.cropper.getResult()

      this.$emit('submit', {
        name: 'avatar',
        value: this.roundEdges(canvas).toDataURL()
      })
      this.$router.push('/create')
    },
    uploadImage(event) {
      const input = event.target

      if (input.files && input.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.image = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    }
  }
}
</script>

<style lang="scss">
.upload {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 92vh;

  .upload__cropper {
    height: 300px;
    width: 100%;
    cursor: auto;
  }

  .button input {
    display: none;
  }
  label {
    display: flex;
    align-items: center;
    font-size: 2.5rem;
    padding: 4rem 2rem;
    flex-wrap: wrap;

    svg {
      height: 3rem;
      margin-left: 1rem;
      fill: white;
    }
  }
  @media screen and (max-width: 40rem) {
    min-height: 82vh;
    height: auto;
  }
}
</style>
